'use strict';

function dropdown_toggle() {
	var dropdown		= document.querySelectorAll(".js-dropdown");
	var dropdownArray	= Array.prototype.slice.call(dropdown,0);

	dropdownArray.forEach(function(el) {
		var trigger = el.querySelector(".js-dropdown-toggle"),
			menu	= el.querySelector(".toggle-item");

		trigger.onclick = function(event) {
			if(!menu.hasClass("is-open")) {
				menu.classList.add("is-open");
			} else {
				menu.classList.remove("is-open");
			}
		};
	});

	Element.prototype.hasClass = function(className) {
	    return this.className && new RegExp("(^|\\s)" + className + "(\\s|$)").test(this.className);
	};

}

dropdown_toggle();